package kz.dentalcrm.app.data.network.request_model

import kotlinx.serialization.Serializable

@Serializable
data class Service(
    val category: Category?,
    val category_id: Int?,
    val created_at: String?,
    val description: String?,
    val duration: Int?,
    val id: Int?,
    val max_price: Int?,
    val name: String?,
    val organization_id: Int?,
    val price: Int?,
    val updated_at: String?
)